import { render, staticRenderFns } from "./IdealerassignvehicleCreate.vue?vue&type=template&id=05e86146&scoped=true"
import script from "./IdealerassignvehicleCreate.vue?vue&type=script&lang=js"
export * from "./IdealerassignvehicleCreate.vue?vue&type=script&lang=js"
import style0 from "./IdealerassignvehicleCreate.vue?vue&type=style&index=0&id=05e86146&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e86146",
  null
  
)

export default component.exports